export default "__VITE_ASSET__BHfhy9Fw__"